import { Fragment, useEffect, useState } from 'react';
import bundle from '@sas/reacteua-novacmneua/novacmneua-gui-eua.properties';
import { addBundle } from '../../../../locale/createUseTextLocalizer';
import { useNCTextLocalizer } from '../../../../locale/useNCTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../../theme';
import { postfixTestId } from '../../../../util/testId';
import { AvatarSelectorWithLabels } from '../../../AvatarSelector';
import { Button } from '../../../Button';
import { Divider } from '../../../Divider';
import { Flow } from '../../../Layouts/Flow';
import { useShowMessageToast } from '../../../MessageToast';
import { Select } from '../../../Select';
import { withLabels } from '../../../withLabels';
import { GlobalSettingsKeys } from '../../GlobalSettingsKeys';
import { useSettingsService } from '../../GlobalSettingsProvider';
import { useIntl } from '../../hooks/useIntl';
import { useSettingsDialogDataProvider } from '../../SettingsDialog/SettingsDialog';
import { useSettingsField } from '../../store/SettingsStore';

// Import CSS Last
import cn from './GeneralForm.css.json';
import './GeneralForm.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
addBundle(bundle);
const SelectWithLabel = withLabels(Select);
const ButtonWithLabel = withLabels(Button);
export const GeneralForm = () => {
  const showMessageToast = useShowMessageToast();
  const localize = useNCTextLocalizer('Settings');
  const formName = 'settings-global-generalForm';
  const {
    writeAccessState: {
      hasWriteAccess
    }
  } = useSettingsService();
  const [currentTheme, setCurrentTheme, resetCurrentTheme] = useSettingsField(GlobalSettingsKeys.THEMES_KEY);
  const {
    0: suppresedMessages,
    2: resetSuppressedMessages
  } = useSettingsField(GlobalSettingsKeys.USER_SUPPRESSED_MESSAGES);
  const helpLibraryDetails = {
    contentKey: 'settings.theme',
    library: 'novacmneua-gui-eua',
    testId: postfixTestId(formName, 'themesHelpPopup')
  };
  const settingsDialogDP = useSettingsDialogDataProvider();
  const hiddenSettings = settingsDialogDP.getHiddenGlobalSettings?.() ?? [];
  const localeInfo = useIntl();
  const [defaultTheme, setDefaultTheme] = useState();
  const [customThemes, setCustomThemes] = useState([]);
  const [systemThemes, setSystemThemes] = useState([]);
  let selectedIndex = 0;
  useEffect(() => {
    let mounted = true;
    const comparator = localeInfo?.getCollator().compare ?? function (a, b) {
      return a > b ? 1 : -1;
    };
    Promise.allSettled([settingsDialogDP.getCustomThemes(), settingsDialogDP.getSystemThemes(), settingsDialogDP.getDefaultTheme()]).then(([customThemesInfo, systemThemesInfo, defaultThemeInfo]) => {
      if (mounted) {
        if ((customThemesInfo && customThemesInfo.status) === 'fulfilled') {
          setCustomThemes(customThemesInfo.value.sort((a, b) => comparator(a.text, b.text)));
        }
        if ((systemThemesInfo && systemThemesInfo.status) === 'fulfilled') {
          setSystemThemes(systemThemesInfo.value.sort((a, b) => comparator(a.text, b.text)));
        }
        if ((defaultThemeInfo && defaultThemeInfo.status) === 'fulfilled') {
          setDefaultTheme(defaultThemeInfo.value);
        }
      }
    });
    return () => {
      mounted = false;
    };
  }, [settingsDialogDP, localeInfo]);
  const defaultThemeItem = {
    id: '',
    text: ''
  };
  if (defaultTheme) {
    defaultThemeItem.text = localize('settings.forms.general.defaultTheme.label', {
      theme: defaultTheme
    });
  }
  const rawThemeList = [defaultThemeItem, ...systemThemes, ...customThemes];
  if (currentTheme && rawThemeList.length > 0) {
    const index = rawThemeList.findIndex(item => item.id === currentTheme);
    selectedIndex = index >= 0 ? index : 0;
  }
  const themesList = [defaultThemeItem, {
    separator: true
  }, ...systemThemes];
  if (customThemes.length > 0) {
    themesList.push({
      separator: true
    }, ...customThemes);
  }
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars({
    'spacing-s': dt.tokens['space-base-s']
  }, 'general-form-avatar');
  return /*#__PURE__*/_jsxs(Flow, {
    orientation: "vertical",
    spacing: "s",
    children: [/*#__PURE__*/_jsx(SelectWithLabel, {
      testId: postfixTestId(formName, 'themes'),
      label: localize('settings.forms.general.themes.label'),
      description: localize('settings.forms.general.themeDescription.label'),
      fieldMinWidth: '100%',
      fieldSuffixMinWidth: '0',
      wrapDescription: true,
      labelHelp: helpLibraryDetails,
      values: themesList,
      selectedIndex: selectedIndex,
      onSelected: index => {
        index = index ?? 0;
        index > 0 ? setCurrentTheme(rawThemeList[index].id) : resetCurrentTheme();
      }
    }), hasWriteAccess ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ButtonWithLabel, {
        testId: postfixTestId(formName, 'resetMessages'),
        label: localize('settings.forms.general.reset.label'),
        text: localize('settings.forms.general.resetMessages.button.label'),
        inputStyle: {
          maxWidth: '100%'
        },
        fieldSuffixMinWidth: '0',
        onPress: () => {
          showMessageToast(localize('settings.forms.general.reset.msg'), {
            closeable: false
          });
          if (suppresedMessages !== undefined) {
            resetSuppressedMessages();
          }
        },
        labelingAttr: "aria-labelledby"
      }), !hiddenSettings.includes(GlobalSettingsKeys.Avatar) && /*#__PURE__*/_jsx(AvatarSelectorWithLabels, {
        testId: postfixTestId(formName, 'avatar'),
        label: localize('settings.forms.general.avatar.label'),
        fieldSuffixMinWidth: '0',
        style: tokens,
        className: cn.avatar,
        imageSelectorProps: {
          showHintText: true,
          showSplitButton: true
        },
        dataProvider: settingsDialogDP
      })]
    }) : null]
  });
};
//# sourceMappingURL=GeneralForm.js.map